export default __webpack_public_path__ + "static/media/interview.848b4f3e.png";